import { Routes } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PaymentThreedResultComponent } from './payment-threed-result/payment-threed-result.component';
import { TimeOutResolve } from '../../shared/resolvers/time-out-resolve';
import { ParentalLeaveNotOkComponent } from './parental-leave-not-ok/parental-leave-not-ok.component';

export const resultRoutes: Routes = [
  {
    path: '',
    redirectTo: 'page-not-found',
    pathMatch: 'full'
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'error/:trackingId',
    component: ErrorComponent
  },
  {
    path: 'parental-leave-not-ok/:trackingId',
    component: ParentalLeaveNotOkComponent
  },
  {
    path: 'timeout/:trackingId',
    component: TimeoutComponent,
    resolve: {items: TimeOutResolve}
  },
  {
    path: 'payment/:trackingId',
    component: PaymentResultComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent
  },
  {
    path: 'payment/threeD/:sessionId/:trackingId',
    component: PaymentThreedResultComponent
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full'
  },
];
